<template lang="pug">
.grid-filter
  p.column-title {{ columnTitle }} (DATE RANGE)
  ed-datepicker(:placeholder='columnTitle'
          placement='inline'
          fit
          v-model='date'
          range
          :ref="'input'"
          @update-date='setRange'
          @inputRange='setFormattedDate'
          hidden
          xformat='dateFormat'
  )
  ed-button.btn.btn-actionbar(@click='apply') {{ t("Apply") }}
  | &nbsp;
  | &nbsp;
  a(href='#' @click.prevent='clear')
    u {{ t("clear filter") }}
</template>

<script>

import {i18n} from '@/lang/lang'

const defaultFormat = 'MM/DD/YYYY'

export default {
  data() {
    return {
      date: null,
      range: null,
      dateFormat: global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat,
      formattedRange: null,
      columnTitle: ''
    }
  },

  created() {
    this.columnTitle = this.params.colDef.headerName
  },

  methods: {
    t: (key) => i18n.t(key),

    getModel: function() {
      return {
        filter: this.range,
        formattedFilter: this.formattedRange
      }
    },

    setModel: function(model) {
      if (model && model.filter) {
        this.date = model.filter
      }
      if (model === null) {
        this.date = null
        this.range = null
        this.formattedRange = null
      }
    },

    isFilterActive: function() {
      return this.date !== null && this.date !== undefined && this.date !== ''
    },

    setRange(value) {
      let start = global.moment(this.date && this.date[0]).format(defaultFormat)
      let end = global.moment(this.date && this.date[1]).format(defaultFormat)
      // this.range = value
      this.range = `${start}_${end}`
    },

    setFormattedDate(value) {
      let start = global.moment(value.start).format(this.dateFormat)
      let end = global.moment(value.end).format(this.dateFormat)

      this.formattedRange = `${start}_${end}`
    },

    apply() {
      this.params.filterChangedCallback()
    },

    clear() {
      this.setModel(null)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-control,
.form-group .form-control {
  @include form-field;
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/filters/date.vue